import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReportSelfInspectionWrapperComponent } from '../components/report-self-inspection-wrapper/report-self-inspection-wrapper.component';
import { TextInputComponent } from '../components/text-input/text-input.component';
import {
  SelfInspcetionWrapperData,
  TextInputData,
} from '../report-input-entities';
import { SelfInspectionBaseClassComponent } from '../self-inspection-base-class/self-inspection-base-class.component';

@Component({
  selector: 'app-self-inspection-text',
  templateUrl: './self-inspection-text.component.html',
  styleUrls: ['./self-inspection-text.component.scss'],
  imports: [TextInputComponent, ReportSelfInspectionWrapperComponent],
})
export class SelfInspectionTextComponent<
  T,
> extends SelfInspectionBaseClassComponent<T> {
  @Input() data: TextInputData;
  @Input() canBeMarkedNotApplicable? = true;
  @Input() wrapperData: SelfInspcetionWrapperData;
  @Output() saveTextInput = new EventEmitter<T>();

  showWarning = false;

  get selfInspectionId(): string {
    return this.data.id;
  }

  saveInput(input: string) {
    this.setIsLoadingTrue();
    this.saveTextInput.emit({ text: input } as T);
  }

  handleHasUnsavedChanges(event: boolean) {
    this.showWarning = event;
  }
}
